<div class="quality-tab" dir="rtl">
  <div *ngIf="loading" class="empty-box">
    <i class="fa fa-spinner fa-spin"></i>
    <span>در حال دریافت اطلاعات کیفیت داده...</span>
  </div>

  <div *ngIf="!loading && !hasData" class="empty-box">
    <i class="fa fa-shield"></i>
    <span>داده‌ای برای بررسی کیفیت وجود ندارد</span>
  </div>

  <ng-container *ngIf="!loading && hasData">
    <section class="kpis">
      <div class="kpi" *ngFor="let k of kpis" [ngClass]="k.cls">
        <div class="t"><i class="fa {{ k.icon }}"></i> {{ k.title }}</div>
        <div class="v">{{ k.value }}</div>
        <div class="d">{{ k.desc }}</div>
      </div>
    </section>

    <div class="grid-2 mt">
      <div class="box">
        <h3><i class="fa fa-tachometer"></i> توزیع اطمینان سرعت اوج (PeakSpeedConfidence)</h3>
        <div class="chart"><canvas id="qualityPeakConf"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-road"></i> توزیع اطمینان مسافت (DistanceConfidence)</h3>
        <div class="chart"><canvas id="qualityDistConf"></canvas></div>
      </div>
    </div>

    <div class="box mt">
      <h3><i class="fa fa-warning"></i> خودروهای با کیفیت داده پایین یا اطمینان مشکوک
        <span *ngIf="totalSuspicious > qualityRows.length" class="sub-note">({{ totalSuspicious }} مورد — نمایش {{ qualityRows.length }} مورد اول)</span>
      </h3>
      <div class="tablewrap">
        <table>
          <thead>
            <tr>
              <th>خودرو / راننده</th>
              <th>پلاک</th>
              <th>حداکثر سرعت</th>
              <th>اطمینان سرعت اوج</th>
              <th>اطمینان مسافت</th>
              <th>کیفیت داده</th>
              <th>هشدار</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let x of qualityRows; trackBy: trackByRow">
              <td class="name">{{ x.strFullName }}</td>
              <td>{{ x.strVehicleNo }}</td>
              <td>{{ x.MaxSpeed }}</td>
              <td [ngClass]="confClass(x.PeakSpeedConfidence)">{{ x.PeakSpeedConfidence }}%</td>
              <td [ngClass]="confClass(x.DistanceConfidence)">{{ x.DistanceConfidence }}%</td>
              <td><span class="badge" [ngClass]="qualityBadge(x.DataQuality)">{{ qualityBadgeLabel(x.DataQuality) }}</span></td>
              <td class="warn">{{ x.MainWarning }}</td>
            </tr>
            <tr *ngIf="!qualityRows.length">
              <td colspan="7" class="empty-cell">همه خودروها کیفیت داده مناسب دارند</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </ng-container>
</div>
